<div class="tw-flex tw-items-center tw-justify-center" *ngIf="loading">
  <bit-icon name="bwi-spinner" class="bwi-spin bwi-3x" [ariaLabel]="'loading' | i18n"></bit-icon>
</div>

<auth-input-password
  *ngIf="!loading"
  [email]="email"
  [flow]="inputPasswordFlow"
  [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
  [loading]="submitting"
  [primaryButtonText]="{ key: 'createAccount' }"
  (onPasswordFormSubmit)="handlePasswordFormSubmit($event)"
></auth-input-password>
